export const colors = {
  primary: "red",
  secondary: "blue",
  error: "#ef3b3b",
  gray: {
    300: "#F8F8F8",
    400: "#DCDFE4",
    500: "#6B7280",
    600: "#a1a1a4",
    700: "#374151",
    900: "#111827",
  },
  green: {
    100: "#D1FAE5",
    800: "#065F46",
  },
  teal: {
    200: "#99F6E4",
    800: "#99F6E4",
  },
  cyan: {
    50: "#e6f8ff",
    100: "#B7E9FF",
    200: "#A5F3FC",
    800: "#155E75",
  },
  orange: {
    200: "#FED7AA",
    800: "#9A3412",
  },
  indigo: {
    200: "#C7D2FE",
    800: "#3730A3",
  },
};
